import { render, staticRenderFns } from "./gameedit.vue?vue&type=template&id=79caf1fc&scoped=true"
import script from "./gameedit.vue?vue&type=script&lang=js"
export * from "./gameedit.vue?vue&type=script&lang=js"
import style0 from "./gameedit.vue?vue&type=style&index=0&id=79caf1fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79caf1fc",
  null
  
)

export default component.exports